import { axios } from '@/utils/request'

const api = {
  master: '/master/area',
}

export function addChannelArea (parameter) {//添加
  return axios({
    url: api.master + '/addChannelArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function editChannelArea (parameter) {//编辑
  return axios({
    url: api.master + '/editChannelArea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectChannelArea (parameter) {//编辑
  return axios({
    url: api.master + '/selectChannelArea',
    method: 'get',
    params: parameter,
  })
}

export function ChannelAreaSearch (parameter) {//查询
  return axios({
    url: api.master + '/ChannelAreaSearch',
    method: 'get',
    params: parameter,

  })
}

export function geographyData(parameter) {//树状图数据
  return axios({
    url: api.master + '/geographyData',
    method: 'get',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function disableChannelArea (parameter) {//禁用
  return axios({
    url: api.master + '/disableChannelArea',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function enableChannelArea (parameter) {//启用
  return axios({
    url: api.master + '/enableChannelArea',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// export const remindMap = {
//   '0': '否',
//   '1': '是'
// }
//
// export const fieldType = {
//   '0': '单选框',
//   '1': '输入框',
//   '2': '单选+输入'
// }

export const channelExport = api.channel + '/export'
